import React from "react";
import { Row, Col } from "antd";
import { VisualTotalInfomation } from "../individual_user/TotalInformation";
import FrequencyGraph from "../FrequencyGraph";
// import CategoryGraph from './CategoryGraph'
import { ContainerLoading } from "../../loading/PersistGateLoading";
import { CompareCol } from "../../../containers/ReportPanels/CompareValuePanel";
import StressGraphDrawer from "./index";

const StressUsageOverview = ({ id, data = {}, isVertical }) => (
	<div>
		<ContainerLoading isLoading={data ? false : true}>
			<StressGraphDrawer beforeCol ={
				<CompareCol isVertical={isVertical}>
					<Row gutter={16}>
						<Col span={12}>
							<VisualTotalInfomation
								total={data ? data.frequency.total_session : 0}
								description='Total Test session' 
								visualColorKey={id}
							/>
						</Col>
						<Col span={12}>
							<VisualTotalInfomation
								total={data ? data.frequency.total_user : 0}
								description='Total users' 
								visualColorKey={id}
							/>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<FrequencyGraph
								data={data ? data.frequency.data : {}}
								date_range={data ? data.date_range : null}
								chart_id={`${id}_frequency_graph`} 
								visualColorKey = {id}
							/>
						</Col>
					</Row>
				</CompareCol>
			} 
			summary={data} 
			isVertical={isVertical} 
			single={isVertical}
			colorType={id}
			/>
		</ContainerLoading>
	</div>
);

export default StressUsageOverview;


// WEBPACK FOOTER //
// ./src/components/report/stress/StressUsageOverview.js